























































































import Vue from 'vue';
import _ from 'lodash';

export default Vue.extend({
  name: 'ThePressoesArteriaisFormDialog',
  props: {
    value: {
      type: Boolean,
    },
    consultaId: {
      type: Number,
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      form: {
        max: null,
        min: null,
        observacoes: null,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    formPressaoArterial(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formPressaoArterial as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean,
      };
    },
  },
  watch: {
    value() {
      this.dialog = this.value;
    },
  },
  methods: {
    // eslint-disable-next-line  func-names
    adicionaDebounce: _.debounce(async function () { await this.adiciona(); }, 200),
    async adiciona() {
      if (!this.formPressaoArterial.validate()) {
        return;
      }
      this.$emit('adicionaPressaoArterial', this.form);
      this.$emit('input', false);
      this.form = {
        max: null,
        min: null,
        observacoes: null,
      };
      this.formPressaoArterial.resetValidation();
    },
  },
});
